import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tCentro/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ SpcPONumber: string }>;

export const DispatchSpcPoNumber: HandlerType = props => {
    props.dispatch({
        type: "Custom/SpcPONumber/SetSpcPONumber",
        SpcPONumber: props.parameter.SpcPONumber,
    });

    props.dispatch({
        type: "Custom/SpcPONumber/SpcPONumberError",
        SpcPONumberError: " ",
    });

    props.dispatch({
        type: "Custom/SpcPONumber/SpcshowFormErrors",
        SpcshowFormErrors: false,
    });
};

export const chain = [DispatchSpcPoNumber];

const setSpcPONumber = createHandlerChainRunner(chain, "setSpcPONumber");
export default setSpcPONumber;
